import React, { useEffect } from 'react';
import { useTooltip } from './TooltipProvider';

export const TooltipManager = () => {
    const tooltipContext = useTooltip();
    if (!tooltipContext) {
        return null;
    }
    const { showTooltip, hideTooltip } = tooltipContext;

    useEffect(() => {
        const handleMouseOver = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const tooltipParent = target?.closest('[data-tooltip]');
            if (tooltipParent) {
                const tooltipText = tooltipParent.getAttribute('data-tooltip');
                const boundingRect = tooltipParent.getBoundingClientRect();
                if (tooltipText) {
                    showTooltip(tooltipText, boundingRect);
                }
            }
        };

        const handleMouseOut = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const tooltipParent = target.closest('[data-tooltip]');
            if (tooltipParent) {
                hideTooltip();
            }
        };

        document.addEventListener('mouseover', handleMouseOver);
        document.addEventListener('mouseout', handleMouseOut);

        return () => {
            document.removeEventListener('mouseover', handleMouseOver);
            document.removeEventListener('mouseout', handleMouseOut);
        };
    }, [showTooltip, hideTooltip]);

    return null;
};

